import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GetCurrentThemeService } from 'src/app/services/TemplateServices/get-current-theme.service';
import { PrettyTooltipService } from 'src/app/services/TemplateServices/pretty-tooltip.service';

@Component({
  selector: 'app-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrls: ['./progress-card.component.scss']
})
export class ProgressCardComponent {

  // percent: Valor porcentual para medir el progreso de la barra
  @Input() percent: number;
  // title: Título
  @Input() title: string;
  // badge: Texto informativo que acompaña al porcentaje
  @Input() badge: string;
  // goal: Valor que se posiciona a la derecha arriba del procentaje
  @Input() goal: string;
  // text1: Textos que se posicionan debajo del procentaje
  @Input() text: string[];
  // showBtn: Si está definido agrega la opción de ver más a la carta
  @Input() showBtn: boolean;
  // textTooltip: Texto para agregar a tooltip
  @Input() textTooltip: string;
  // shareIncident: Comparte información al componente padre
  @Output() shareIncident: EventEmitter<string> = new EventEmitter();

  constructor(
    public currentTheme: GetCurrentThemeService,
    public prettyTooltip: PrettyTooltipService,
  ) { }

  /* showIncidents(): Método que comparte los incidentes segun el indicador seleccionado
    title: Valor a compartir
  */
  showIncidents(title: string) { this.shareIncident.emit(title); }

}
